__webpack_require__.p = "/app/predictor/hair/";